module.exports = __webpack_public_path__ + "static/img/12.0b3b570.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/12.png
// module id = 3zqz
// module chunks = 0